import { action } from "satcheljs";

export interface Win32StyleCommittedActionMessage {
    isEnabled: boolean;
}

const onWin32StyleCommitted: (isEnabled: boolean) => Win32StyleCommittedActionMessage = action("onWin32StyleCommitted", (isEnabled: boolean): Win32StyleCommittedActionMessage => ({
    isEnabled,
}));

export default onWin32StyleCommitted;
